<template>
    <div>
      <h6 v-if="profileId == 0" class="heading-small text-muted mb-4">
        Add New Site Type {{ inputName ? " - " + this.inputName : "" }}
      </h6>
      <h6
        v-else-if="profileId != 0 && this.$attrs.viewMode == true"
        class="heading-small text-muted mb-4"
      >
        View Site Type - {{ this.inputName }}
      </h6>
      <h6 v-else class="heading-small text-muted mb-4">
        Edit Site Type - {{ this.inputName }}
      </h6>
  
      <base-alert v-if="errors.length" type="danger">
        <b>You have the following error(s):</b>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </base-alert>
  
      <b-tabs
        v-show="profileId != 0 && this.$attrs.viewMode == true"
        content-class="mt-3"
      >
        <b-tab title="Details" active v-on:click="openDetails"></b-tab>
        <b-tab title="History" v-on:click="openHistory">
          <b><label>Created By: </label></b>
          {{ site_type.created_by || "System"  }} | {{ site_type.created_at | dateFilter }}
          <br />
          <b><label>Updated By:</label></b>
          {{ site_type.updated_by || "System"  }} | {{ site_type.updated_at | dateFilter }}
        </b-tab>
      </b-tabs>
  
      <form id="form-proper">
        <!-- {{site_type}} -->
        <div v-if="customFormMode == 1" v-show="showDetails">
          <!-- Normal -->
          <base-input
            alternative=""
            label="Code"
            placeholder=""
            v-model="site_type.code"
            input-classes="form-control"
          />
          <base-input
            alternative=""
            label="Name"
            placeholder=""
            v-model="site_type.name"
            input-classes="form-control"
            required
          />
          <base-input
            alternative=""
            label="Refcode"
            placeholder=""
            v-model="site_type.refcode"
            input-classes="form-control"
          />
          <base-input alternative="" label="Remark">
            <textarea rows="4" class="form-control" v-model="site_type.remark" />
          </base-input>

          <base-checkbox class="mb-3" v-model="isChannelType"
            >Channel Type</base-checkbox
          >
        </div>
        <div v-if="customFormMode == 2">
          <!-- Override -->
          <dynamic-form
            :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
            :formSettings="site_type"
            @valueUpdated="updateSettings"
            :key="dynamicFormKey"
          />
        </div>
        <div v-if="customFormMode == 3">
          <!-- Append -->
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <base-input
                alternative=""
                label="Code"
                placeholder=""
                v-model="site_type.code"
                input-classes="form-control"
              />
              <base-input
                alternative=""
                label="Name"
                placeholder=""
                v-model="site_type.name"
                input-classes="form-control"
                required
              />
              <base-input
                alternative=""
                label="Refcode"
                placeholder=""
                v-model="site_type.refcode"
                input-classes="form-control"
              />
              <base-input alternative="" label="Remark">
                <textarea rows="4" class="form-control" v-model="site_type.remark" />
              </base-input>
              
              <base-checkbox class="mb-3" v-model="site_type.isChannelType"
                >Channel Type</base-checkbox
              >
            </a-tab-pane>
            <a-tab-pane tab="Custom Fields" key="2" forceRender>
              <dynamic-form
                :convertedJson="{
                  mode: customForm.mode,
                  groups: customForm.groups_append,
                }"
                :formSettings="site_type"
                @valueUpdated="updateSettings"
                :key="dynamicFormKey"
                :showErrors="false"
              />
            </a-tab-pane>
          </a-tabs>
        </div>
  
        <div v-if="this.$attrs.viewMode != true">
          <div
            v-if="serverType == 'ho'"
            style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
          >
            <button
              v-if="profileId == 0"
              type="button"
              class="btn btn-primary float-right"
              @click.prevent="create"
            >
              Create
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary float-right"
              @click.prevent="update"
            >
              Update
            </button>
          </div>
          <div
            v-else
            style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
          >
            <button
              type="button"
              class="btn btn-primary float-right"
              @click.prevent="$emit('closeDrawer', null)"
            >
              Close
            </button>
          </div>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import HTTPRequest from "../../controllers/httpRequest.js";
  import ValidateField from "../../components/validateFormUtils.js";
  import DynamicForm from "../DynamicForm.vue";
  import { mapState } from "vuex";
  import moment from "moment";
  var component_x;
  export default {
    components: {
      DynamicForm,
    },
    computed: {
      ...mapState(["endPoint", "profileId", "serverType"]),
    },
    mounted: async function() {
      const sytemModule = await HTTPRequest.getRequest(
        this.endPoint + "system_modules/Site Type?field_name=name",
        null
      );
      const sytemModuleId = sytemModule.id;
      const accSystemModuleRequest = await HTTPRequest.getRequest(
        this.endPoint +
          "account_system_modules/" +
          sytemModuleId +
          "?field_name=system_module_id",
        null
      );
      if (this.isJsonString(accSystemModuleRequest.meta) == true) {
        const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
        if (accSystemModule != null) {
          if (accSystemModule.form_mode != undefined) {
            this.customFormMode = accSystemModule.form_mode;
          }
          if (accSystemModule.customized_forms != undefined) {
            this.customForm = accSystemModule.customized_forms;
          }
        }
      }
  
      if (this.serverType == "branch" || this.$attrs.viewMode == true) {
        var form = document.getElementById("form-proper");
        var elements = form.elements;
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].readOnly = true;
        }
      }
      component_x = this;
      if (component_x.profileId > 0) {
        var site_type_data = await HTTPRequest.getRequest(
          component_x.endPoint + "site_types/" + component_x.profileId,
          null
        );
        if (site_type_data == undefined) {
          component_x.$router.go();
        } else {
          if (site_type_data["error"] == undefined) {
            component_x.site_type = site_type_data;
            component_x.inputName = site_type_data["name"];
            component_x.inputCode = site_type_data["code"];
            component_x.inputRefcode = site_type_data["refcode"];
            component_x.inputRemark = site_type_data["remark"];
            component_x.isChannelType = site_type_data["is_channel"]
          } else {
            this.errors = site_type_data["error"].split(",");
          }
        }
      }
  
      this.dynamicFormKey++;
    },
    data: function() {
      return {
        inputName: "",
        inputCode: "",
        inputRemark: "",
        errors: [],
        showDetails: true,
  
        customFormMode: 1,
        customForm: {},
        profileData: {},
        dynamicFormKey: 0,
        site_type: {},
        formErrors: [],
        isChannelType: false
      };
    },
    filters: {
      dateFilter: function(timestamp) {
        return moment(timestamp).format("L LTS");
      },
    },
    methods: {
      updateSettings(newFormSettings, settingsGrouping, errors) {
        var formSettingsCopy = this.bagger;
        var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
        this.formErrors = errors;
        if (this.customFormMode == 3) {
          this.errors = errors;
        }
        this.bagger = mergedHash;
      },
      isJsonString(str) {
        try {
          var json = JSON.parse(str);
          return typeof json === "object";
        } catch (e) {
          return false;
        }
      },
      openDetails() {
        this.showDetails = true;
      },
      openHistory() {
        this.showDetails = false;
      },
      validateForm() {
        this.errors = [];
        // this.errors.push(ValidateField.required('Code', this.inputCode));
        // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.site_type.code));
        this.errors.push(
          ValidateField.charMinAndMax("Code", this.site_type.code, 0, 30)
        );
        this.errors.push(
          ValidateField.charMinAndMax("Refcode", this.site_type.refcode, 0, 30)
        );
        this.errors.push(ValidateField.required("Name", this.site_type.name));
        // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.site_type.name));
        this.errors.push(
          ValidateField.charMinAndMax("Name", this.site_type.name, 0, 50)
        );
        this.errors = this._.compact(this.errors);
        document.getElementsByClassName(
          "ant-drawer-wrapper-body"
        )[0].scrollTop = 0;
        return this.errors.length;
      },
      create: async function() {
        if (!this.validateForm()) {
          // var site_typePayload = {
          //     site_type: {
          //         name: this.inputName.trim(),
          //         code: this.inputCode.trim(),
          //         remark: this.inputRemark,
          //         status: 'A'
          //     }
          // }
  
          this.site_type.name = this.site_type.name.trim();
          if (this.site_type.code != undefined)
            this.site_type.code = this.site_type.code.trim();
          if (this.site_type.refcode != undefined)
            this.site_type.refcode = this.site_type.refcode.trim();
          this.site_type.status = "A";
          this.site_type.is_channel = this.isChannelType
          var site_typePayload = { site_type: this.site_type };
  
          var post_request = await HTTPRequest.postRequest(
            this.endPoint + "site_types",
            null,
            site_typePayload
          );
          if (post_request == undefined) {
            this.$emit("refreshPage", event);
          } else {
            if (post_request["error"] == undefined) {
              this.$emit("refreshPage", event);
            } else {
              this.errors = post_request["error"].split(",");
            }
          }
        }
      },
      update: async function() {
        if (!this.validateForm()) {
          // var site_typePayload = {
          //     site_type: {
          //         name: this.inputName.trim(),
          //         code: this.inputCode.trim(),
          //         remark: this.inputRemark,
          //         status: 'A'
          //     }
          // }
  
          this.site_type.name = this.site_type.name.trim();
          if (this.site_type.code != undefined)
            this.site_type.code = this.site_type.code.trim();
          if (this.site_type.refcode != undefined)
            this.site_type.refcode = this.site_type.refcode.trim();
          // this.site_type.status = 'A'
          let status = this.site_type.status == null ? "A" : this.site_type.status;
          this.site_type.status = status;
          this.site_type.is_channel = this.isChannelType
          var site_typePayload = { site_type: this.site_type };
  
          var put_request = await HTTPRequest.putRequest(
            this.endPoint + "site_types/" + this.profileId,
            null,
            site_typePayload
          );
          if (put_request == undefined) {
            this.$emit("refreshPage", event);
          } else {
            if (put_request["error"] == undefined) {
              this.$emit("refreshPage", event);
            } else {
              this.errors = put_request["error"].split(",");
            }
          }
        }
      },
    },
  };
  </script>
  
  <style></style>
  